import { useApi } from '../services';

export const useGetDocuments = (idOperation) => useApi(
  `v2/operation/${idOperation}/documents`,
  'GET',
  {},
  {}
);

export const useGetDocumentsAsync = (idOperation) => useApi(
  `v2/operation/${idOperation}/documents`,
  'GET',
  {},
  {},
  true
);

export const useGetDocumentsParams = () => useApi(
  `v2/operation/documents/params`,
  'GET',
  {},
  {}
);

export const useCreateDocumentAsync = (idOperation) => useApi(
  `v2/operation/${idOperation}/documents`,
  'POST',
  {},
  {},
  true
);

export const useUpdateDocument = (idOperation, idDocument) => useApi(
  `v2/operation/${idOperation}/documents/${idDocument}`,
  'PUT',
  {},
  {}
);

export const useSendDocuments = (idOperation) => useApi(
  `v2/operation/${idOperation}/documents/send-documents`,
  'POST',
  {},
  {}
);